<div class="pos-relative flex flex-wrap flex-middle _wrapWithoutPadding"
     [ngClass]="[component.sideBgColor || '', !component.sideImageRight && client.sizeId > 1 ? 'flex-reverse': '' ].join(' ')">
    <div class="w-12"
         (click)="navigateToLink()">
        <div class="overflow-hidden"
             [ngClass]="[component.ratio || 'ratio-3-2', component.sideImage && client.sizeId > 1 ? 'w-6' : 'w-12'].join(' ')">
            <image-video [source]="component"
                         [ratio]="component.ratio || 'ratio-3-2'" />

            @if(!component.sideImage) {
            <div class="wrap-l wrap-x">
                <div class="pos-absolute p-t-10 p-b-10 wrap-s wrap-m"
                     [ngClass]="boxPostition">
                    <ng-container *ngTemplateOutlet="textBox"></ng-container>
                </div>
            </div>
            }
        </div>
        @if(component.sideImage) {
        <div class="w-6 w-12-s w-12-m p-a-10 wrap-s wrap-m p-t-10 p-b-10 p-t-16-s p-b-16-s p-t-16-m p-b-16-m"
             [sizeClass]="'S: _fullHeight, SM: flex-column flex-justify-center'">
            <ng-container *ngTemplateOutlet="textBox"></ng-container>
        </div>
        }
    </div>
</div>


<ng-template #textBox>
    <text [variant]="component.textComponentVariat || 'default'"
          class="w-12"
          [ngClass]="component.boxAlignement === 'center' ? 'center' : 'flex-middle'"
          [content]="component"></text>
</ng-template>